/* eslint-disable react/prop-types */
import { ToastNotification as CarbonToastNotification } from '@carbon/react';

export const ToastNotification = ({ children, ...props }) => (
  <CarbonToastNotification {...props}>{children}</CarbonToastNotification>
);
